import { render, staticRenderFns } from "./CellRendererRole.vue?vue&type=template&id=bbb997f8&scoped=true&"
import script from "./CellRendererRole.vue?vue&type=script&lang=js&"
export * from "./CellRendererRole.vue?vue&type=script&lang=js&"
import style0 from "./CellRendererRole.vue?vue&type=style&index=0&id=bbb997f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb997f8",
  null
  
)

export default component.exports